import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'
import { Score } from '@maui/score'

export const MScoreDetails = ({ score, verdict, variant, summaryOnly, skeletonOnly, ...containerProps }) => {
  if (summaryOnly || skeletonOnly) {
    return (
      <Box
        borderBottomStyle="solid"
        borderBottomColor="colorBorderMain"
        borderBottomWidth="1px"
        paddingBottom="spacePaddingXLarge"
        {...containerProps}
      >
        <Score score={score} verdict={verdict} variant={variant} summaryOnly={summaryOnly || false} />
      </Box>
    )
  }

  return (
    <Score.Panel {...containerProps}>
      <Score score={score} verdict={verdict} />
    </Score.Panel>
  )
}

MScoreDetails.propTypes = {
  score: PropTypes.number.isRequired,
  verdict: PropTypes.object,
  summaryOnly: PropTypes.bool,
  skeletonOnly: PropTypes.bool,
}

export default MScoreDetails
